import React, { useState } from 'react';
import { copyText } from '../../../utils/helper';
import CopyIcon from '../svgIcons/CopyIcon';
import StyledToolTip from './StyledToolTip';

const StyledCopy = ({ text, size }) => {
  const [linkCopied, setLinkCopied] = useState(false);

  return (
    <StyledToolTip
      title={linkCopied ? 'Copied' : 'Copy to clipboard'}
      className="mt-2"
      placement="top"
    >
      <span
        onClick={() => {
          copyText(text);
          setLinkCopied(true);
        }}
      >
        <CopyIcon className="cursor-pointer" size ={size}/>
      </span>
    </StyledToolTip>
  );
};

export default StyledCopy;
